import React, { Component } from "react";
//import axios from 'axios';
import { connect } from "react-redux";
import { Route, Switch } from 'react-router-dom';

import { ViewEquipment, EquipmentEdit, EquipmentCreate } from "./SubEquipment";

//import { fetchInfo } from '../../actions/';

class Equipment extends Component {
    render() {
        const { session:{currentUser} } = this.props;

        return (
            <div>
                <Switch>
                    <Route
                        exact
                        path={`/profile/${currentUser.id}/equipment`}
                        render={(props) =>
                            (<ViewEquipment
                                {...props}
                                toggleDeleteModal={(equipment) => this.props.toggleDeleteModal(equipment)}
                                />
                        )} />
                    
                    <Route path={`/profile/${currentUser.id}/equipment/create`} render={(props) => {
                        return (<EquipmentCreate {...props} />)
                    }} />

                    <Route path={`/profile/${currentUser.id}/equipment/edit/:id`} render={(props) => {
                        return (<EquipmentEdit {...props} />)
                    }} />
                </Switch>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(mapStateToProps)(Equipment);


// WEBPACK FOOTER //
// ./src/components/Profile/Equipment.js